import { logFrontendError } from '../apis/GeneralApis/ErrorLogAPI';

export const setupGlobalErrorHandlers = () => {
  let lastErrorTime = 0;
  const DEBOUNCE_TIME = 1000; 

  window.addEventListener('error', (event) => {
    const currentTime = Date.now();
    if (currentTime - lastErrorTime < DEBOUNCE_TIME) {
      return;
    }
    lastErrorTime = currentTime;

    const error = event.error || {
      message: event.message || 'Unknown error',
      stack: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : null,
    };

    logFrontendError({
      message: error.message || event.message || 'Unhandled JavaScript error',
      stack: error.stack || `${event.filename}:${event.lineno}:${event.colno}`,
      errorType: 'error',
      url: window.location.href,
      source: 'GlobalErrorHandler',
      errorInfo: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: error.toString(),
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const currentTime = Date.now();
    if (currentTime - lastErrorTime < DEBOUNCE_TIME) {
      return;
    }
    lastErrorTime = currentTime;

    const error = event.reason || {};
    let message = 'Unhandled promise rejection';
    let stack = null;

    if (error instanceof Error) {
      message = error.message || message;
      stack = error.stack || null;
    } else if (typeof error === 'string') {
      message = error;
    } else if (error && typeof error === 'object') {
      message = error.message || JSON.stringify(error) || message;
      stack = error.stack || null;
    }

    logFrontendError({
      message: message,
      stack: stack,
      errorType: 'unhandledrejection',
      url: window.location.href,
      source: 'GlobalErrorHandler',
      errorInfo: {
        reason: error,
        promise: event.promise,
      },
    });
  });

  const originalConsoleError = console.error;
  console.error = function (...args) {
    originalConsoleError.apply(console, args);

    const errorArg = args.find(arg => arg instanceof Error);
    if (errorArg && errorArg.stack) {
      const errorMessage = errorArg.message || String(errorArg);
      if (errorMessage && errorArg.stack) {
        logFrontendError({
          message: errorMessage,
          stack: errorArg.stack,
          errorType: 'console_error',
          url: window.location.href,
          source: 'ConsoleError',
          errorInfo: {
            consoleArgs: args.map(arg => 
              typeof arg === 'object' ? JSON.stringify(arg) : String(arg)
            ).join(' '),
          },
        });
      }
    }
  };
};

